import type { Lead } from '@/types';

export const mockLeadsExtra: Lead[] = [
  {
    id: 'lead-030',
    funnel_id: 'funnel-002',
    property_id: 'lijn-vast-nl',
    vertical_id: 'real_estate',
    geo_id: 'US-NY-NYC',
    lead_token: 'token-030-b1c',
    firstname: 'James',
    lastname: 'Wilson',
    email: 'james.wilson@email.com',
    phone: '+1 212 555 2345',
    postcode: '10003',
    city: 'New York',
    country_code: 'US',
    ip_address: '203.0.113.200',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0)',
    source_url: 'https://lijnvast.nl/kopen',
    utm_source: 'google',
    utm_medium: 'cpc',
    utm_campaign: 'nyc-buyers-q2',
    utm_content: null,
    utm_term: null,
    referrer: 'https://google.com',
    intake_data: {
      lead_type: 'buyer',
      property_type: 'residential',
      price_range_min: 550000,
      price_range_max: 850000,
      currency: 'USD',
      timeline: 'immediately',
      pre_approved: true,
      num_bedrooms: '2',
      target_neighborhoods: ['Chelsea', 'Gramercy'],
      motivation: 'relocation'
    },
    quality_score: 0.89,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: null,
    tcpa_consent_text: null,
    tcpa_consent_at: null,
    assigned_offer_id: 'offer-002',
    assigned_partner_id: 'partner-002',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-06T09:15:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-06T09:20:00Z',
    phone_verified: true,
    status: 'viewing_scheduled',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-06T09:20:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-06T09:10:00Z',
    updated_at: '2025-05-06T14:00:00Z',
    contacted_at: '2025-05-06T10:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Pre-approved, relocating from Boston. Viewing 2 units Thursday.'
  },
  {
    id: 'lead-031',
    funnel_id: 'funnel-002',
    property_id: 'lijn-vast-nl',
    vertical_id: 'real_estate',
    geo_id: 'US-NY-NYC',
    lead_token: 'token-031-c2d',
    firstname: 'Emily',
    lastname: 'Davis',
    email: 'emily.davis@email.com',
    phone: '+1 212 555 6789',
    postcode: '10011',
    city: 'New York',
    country_code: 'US',
    ip_address: '203.0.113.210',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
    source_url: 'https://lijnvast.nl/kopen',
    utm_source: 'organic',
    utm_medium: 'search',
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    referrer: 'https://google.com',
    intake_data: {
      lead_type: 'buyer',
      property_type: 'residential',
      price_range_min: 400000,
      price_range_max: 650000,
      currency: 'USD',
      timeline: '1_3_months',
      pre_approved: false,
      num_bedrooms: '1',
      target_neighborhoods: ['Lower East Side', 'East Village'],
      motivation: 'first_time'
    },
    quality_score: 0.65,
    quality_flags: ['not_pre_approved'],
    fraud_signals: [],
    tcpa_consent: null,
    tcpa_consent_text: null,
    tcpa_consent_at: null,
    assigned_offer_id: 'offer-002',
    assigned_partner_id: 'partner-002',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-07T11:30:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-07T11:35:00Z',
    phone_verified: true,
    status: 'new',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-07T11:35:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-07T11:25:00Z',
    updated_at: '2025-05-07T11:25:00Z',
    contacted_at: null,
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'First-time buyer, not pre-approved. Needs mortgage guidance.'
  },
  {
    id: 'lead-032',
    funnel_id: 'funnel-002',
    property_id: 'lijn-vast-nl',
    vertical_id: 'real_estate',
    geo_id: 'US-NY-NYC',
    lead_token: 'token-032-d3e',
    firstname: 'Christopher',
    lastname: 'Brown',
    email: 'chris.brown@email.com',
    phone: '+1 212 555 4321',
    postcode: '10013',
    city: 'New York',
    country_code: 'US',
    ip_address: '203.0.113.220',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    source_url: 'https://lijnvast.nl/kopen',
    utm_source: 'facebook',
    utm_medium: 'social',
    utm_campaign: 'nyc-buyers-q2',
    utm_content: null,
    utm_term: null,
    referrer: 'https://facebook.com',
    intake_data: {
      lead_type: 'buyer',
      property_type: 'residential',
      price_range_min: 700000,
      price_range_max: 1100000,
      currency: 'USD',
      timeline: 'immediately',
      pre_approved: true,
      num_bedrooms: '3',
      target_neighborhoods: ['Soho', 'Nolita'],
      motivation: 'investment'
    },
    quality_score: 0.92,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: null,
    tcpa_consent_text: null,
    tcpa_consent_at: null,
    assigned_offer_id: 'offer-002',
    assigned_partner_id: 'partner-002',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-08T08:45:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-08T08:50:00Z',
    phone_verified: true,
    status: 'contacted',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-08T08:50:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-08T08:40:00Z',
    updated_at: '2025-05-08T12:00:00Z',
    contacted_at: '2025-05-08T10:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Investment buyer, pre-approved. Looking at 2 condos in Soho.'
  },
  {
    id: 'lead-033',
    funnel_id: 'funnel-005',
    property_id: 'loan-smart-us',
    vertical_id: 'loans',
    geo_id: 'US-CA',
    lead_token: 'token-033-e4f',
    firstname: 'Michael',
    lastname: 'Anderson',
    email: 'michael.anderson@email.com',
    phone: '+1 415 555 8765',
    postcode: '94104',
    city: 'San Francisco',
    country_code: 'US',
    ip_address: '203.0.113.230',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
    source_url: 'https://loansmart.com/mortgage',
    utm_source: 'google',
    utm_medium: 'cpc',
    utm_campaign: 'ca-mortgage-spring',
    utm_content: null,
    utm_term: 'mortgage refinance san francisco',
    referrer: 'https://google.com',
    intake_data: {
      loan_type: 'mortgage',
      loan_amount_min: 450000,
      loan_amount_max: 750000,
      currency: 'USD',
      credit_score_range: 'good_700_749',
      employment_status: 'employed_fulltime',
      purpose: 'refinance',
      existing_debt: 'manageable',
      tcpa_consent: true,
      tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my mortgage inquiry.',
      tcpa_consent_at: '2025-05-06T14:00:00Z'
    },
    quality_score: 0.83,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my mortgage inquiry.',
    tcpa_consent_at: '2025-05-06T14:00:00Z',
    assigned_offer_id: 'offer-005',
    assigned_partner_id: 'partner-005',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-06T14:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-06T14:10:00Z',
    phone_verified: true,
    status: 'application_started',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: null,
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-06T13:55:00Z',
    updated_at: '2025-05-06T17:00:00Z',
    contacted_at: '2025-05-06T15:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Good credit, refinancing primary residence. Application submitted.'
  },
  {
    id: 'lead-034',
    funnel_id: 'funnel-005',
    property_id: 'loan-smart-us',
    vertical_id: 'loans',
    geo_id: 'US-CA',
    lead_token: 'token-034-f5g',
    firstname: 'Amanda',
    lastname: 'Taylor',
    email: 'amanda.taylor@email.com',
    phone: '+1 415 555 5432',
    postcode: '94105',
    city: 'San Francisco',
    country_code: 'US',
    ip_address: '203.0.113.240',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0)',
    source_url: 'https://loansmart.com/mortgage',
    utm_source: 'organic',
    utm_medium: 'search',
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    referrer: 'https://google.com',
    intake_data: {
      loan_type: 'home_equity',
      loan_amount_min: 200000,
      loan_amount_max: 400000,
      currency: 'USD',
      credit_score_range: 'excellent_750+',
      employment_status: 'self_employed',
      purpose: 'home_improvement',
      existing_debt: 'manageable',
      tcpa_consent: true,
      tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my loan inquiry.',
      tcpa_consent_at: '2025-05-07T10:00:00Z'
    },
    quality_score: 0.91,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my loan inquiry.',
    tcpa_consent_at: '2025-05-07T10:00:00Z',
    assigned_offer_id: 'offer-005',
    assigned_partner_id: 'partner-005',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-07T10:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-07T10:10:00Z',
    phone_verified: true,
    status: 'contacted',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: null,
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-07T10:00:00Z',
    updated_at: '2025-05-07T13:00:00Z',
    contacted_at: '2025-05-07T11:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Excellent credit, self-employed. Home equity for kitchen remodel.'
  },
  {
    id: 'lead-035',
    funnel_id: 'funnel-005',
    property_id: 'loan-smart-us',
    vertical_id: 'loans',
    geo_id: 'US-CA',
    lead_token: 'token-035-g6h',
    firstname: 'Daniel',
    lastname: 'Martinez',
    email: 'daniel.martinez@email.com',
    phone: '+1 415 555 7890',
    postcode: '94107',
    city: 'San Francisco',
    country_code: 'US',
    ip_address: '203.0.113.250',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    source_url: 'https://loansmart.com/mortgage',
    utm_source: 'google',
    utm_medium: 'cpc',
    utm_campaign: 'ca-mortgage-spring',
    utm_content: null,
    utm_term: 'home purchase loan san francisco',
    referrer: 'https://google.com',
    intake_data: {
      loan_type: 'mortgage',
      loan_amount_min: 800000,
      loan_amount_max: 1200000,
      currency: 'USD',
      credit_score_range: 'fair_650_699',
      employment_status: 'employed_fulltime',
      purpose: 'home purchase',
      existing_debt: 'manageable',
      tcpa_consent: true,
      tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my mortgage inquiry.',
      tcpa_consent_at: '2025-05-08T09:00:00Z'
    },
    quality_score: 0.77,
    quality_flags: ['fair_credit'],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I consent to be contacted by phone and SMS regarding my mortgage inquiry.',
    tcpa_consent_at: '2025-05-08T09:00:00Z',
    assigned_offer_id: 'offer-005',
    assigned_partner_id: 'partner-005',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-08T09:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-08T09:10:00Z',
    phone_verified: true,
    status: 'new',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: null,
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-08T09:00:00Z',
    updated_at: '2025-05-08T09:00:00Z',
    contacted_at: null,
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Fair credit, high loan amount. First-time buyer in SF market.'
  },
  {
    id: 'lead-036',
    funnel_id: 'funnel-003',
    property_id: 'future-legal-site',
    vertical_id: 'legal',
    geo_id: 'US-TX',
    lead_token: 'token-036-h7i',
    firstname: 'Jessica',
    lastname: 'Rodriguez',
    email: 'jessica.rodriguez@email.com',
    phone: '+1 713 555 2345',
    postcode: '77004',
    city: 'Houston',
    country_code: 'US',
    ip_address: '203.0.113.260',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0)',
    source_url: 'https://future-legal-site.com/personal-injury',
    utm_source: 'google',
    utm_medium: 'cpc',
    utm_campaign: 'tx-pi-spring-2025',
    utm_content: null,
    utm_term: 'personal injury lawyer houston',
    referrer: 'https://google.com',
    intake_data: {
      case_type: 'slip_and_fall',
      incident_date: '2025-04-15',
      incident_description: 'Fell in grocery store parking lot, fractured ankle',
      injury_severity: 'moderate',
      represented: false,
      jurisdiction_state: 'US-TX',
      case_value_estimate: '10k_50k',
      tcpa_consent: true,
      tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
      tcpa_consent_at: '2025-05-06T11:00:00Z'
    },
    quality_score: 0.81,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
    tcpa_consent_at: '2025-05-06T11:00:00Z',
    assigned_offer_id: 'offer-006',
    assigned_partner_id: 'partner-006',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-06T11:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-06T11:10:00Z',
    phone_verified: true,
    status: 'contacted',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-06T11:10:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-06T10:55:00Z',
    updated_at: '2025-05-06T15:00:00Z',
    contacted_at: '2025-05-06T14:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Slip and fall in commercial property. Clear liability, store has cameras.'
  },
  {
    id: 'lead-037',
    funnel_id: 'funnel-003',
    property_id: 'future-legal-site',
    vertical_id: 'legal',
    geo_id: 'US-TX',
    lead_token: 'token-037-i8j',
    firstname: 'William',
    lastname: 'Harris',
    email: 'william.harris@email.com',
    phone: '+1 713 555 6789',
    postcode: '77005',
    city: 'Houston',
    country_code: 'US',
    ip_address: '203.0.113.270',
    user_agent: 'Mozilla/5.0 (Android 14; Mobile)',
    source_url: 'https://future-legal-site.com/personal-injury',
    utm_source: 'organic',
    utm_medium: 'search',
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    referrer: 'https://google.com',
    intake_data: {
      case_type: 'workers_comp',
      incident_date: '2025-03-20',
      incident_description: 'Construction site fall from scaffolding, broken leg',
      injury_severity: 'severe',
      represented: false,
      jurisdiction_state: 'US-TX',
      case_value_estimate: '50k_250k',
      tcpa_consent: true,
      tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
      tcpa_consent_at: '2025-05-07T08:00:00Z'
    },
    quality_score: 0.87,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
    tcpa_consent_at: '2025-05-07T08:00:00Z',
    assigned_offer_id: 'offer-006',
    assigned_partner_id: 'partner-006',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-07T08:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-07T08:10:00Z',
    phone_verified: true,
    status: 'consultation_scheduled',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-07T08:10:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-07T08:00:00Z',
    updated_at: '2025-05-07T12:00:00Z',
    contacted_at: '2025-05-07T09:00:00Z',
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Construction workers comp, severe injury. OSHA report filed.'
  },
  {
    id: 'lead-038',
    funnel_id: 'funnel-003',
    property_id: 'future-legal-site',
    vertical_id: 'legal',
    geo_id: 'US-TX',
    lead_token: 'token-038-j9k',
    firstname: 'Stephanie',
    lastname: 'Clark',
    email: 'stephanie.clark@email.com',
    phone: '+1 713 555 4321',
    postcode: '77006',
    city: 'Houston',
    country_code: 'US',
    ip_address: '203.0.113.280',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    source_url: 'https://future-legal-site.com/personal-injury',
    utm_source: 'facebook',
    utm_medium: 'social',
    utm_campaign: 'tx-pi-spring-2025',
    utm_content: null,
    utm_term: null,
    referrer: 'https://facebook.com',
    intake_data: {
      case_type: 'auto_accident',
      incident_date: '2025-04-28',
      incident_description: 'Head-on collision, airbag deployment, whiplash',
      injury_severity: 'moderate',
      represented: false,
      jurisdiction_state: 'US-TX',
      case_value_estimate: '10k_50k',
      tcpa_consent: true,
      tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
      tcpa_consent_at: '2025-05-08T10:00:00Z'
    },
    quality_score: 0.78,
    quality_flags: [],
    fraud_signals: [],
    tcpa_consent: true,
    tcpa_consent_text: 'I agree to receive calls and texts about my legal case.',
    tcpa_consent_at: '2025-05-08T10:00:00Z',
    assigned_offer_id: 'offer-006',
    assigned_partner_id: 'partner-006',
    routing_status: 'assigned',
    routing_completed_at: '2025-05-08T10:05:00Z',
    duplicate_of_lead_id: null,
    validation_status: 'valid',
    validation_completed_at: '2025-05-08T10:10:00Z',
    phone_verified: true,
    status: 'new',
    partner_outcome_signal: null,
    outcome_recorded_at: null,
    cpl_payable_at: '2025-05-08T10:10:00Z',
    cpa_event_at: null,
    cpa_event_value_eur: null,
    created_at: '2025-05-08T10:00:00Z',
    updated_at: '2025-05-08T10:00:00Z',
    contacted_at: null,
    quoted_at: null,
    signed_at: null,
    completed_at: null,
    deleted_at: null,
    operator_notes: 'Auto accident, moderate injury. Police report available.'
  }
];